import Icon from '../components/Icon.vue'

Icon.register({
  cut: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M278.1 256L444.5 89.6C449.2 84.9 449.2 77.3 444.5 72.6 411.7 39.8 358.5 39.8 325.7 72.6L210.2 188.1 185.3 163.3C189.6 152.3 192 140.4 192 128 192 75 149 32 96 32S0 75 0 128 43 224 96 224C100.5 224 105 223.7 109.4 223.1L142.3 256 109.4 288.9C105 288.3 100.5 288 96 288 43 288 0 331 0 384S43 480 96 480 192 437 192 384C192 371.6 189.6 359.7 185.3 348.7L210.2 323.9 325.7 439.4C358.5 472.2 411.7 472.2 444.5 439.4 449.2 434.7 449.2 427.1 444.5 422.4L278.1 256zM96 160C78.4 160 64 145.6 64 128S78.4 96 96 96 128 110.4 128 128 113.6 160 96 160zM96 416C78.4 416 64 401.6 64 384S78.4 352 96 352 128 366.4 128 384 113.6 416 96 416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cut.js
// module id = WB1I
// module chunks = 144